<template>
	<div>
      <label class="field_label" :class="isFieldRequired ? 'req' : ''">{{ label }}</label>
      <template v-if="isDescriptionHtml">
          <p class="field_description" v-if="description" v-html="description"></p>
      </template>
      <template v-else>
          <p class="field_description" v-if="description">{{ description }}</p>
      </template>
      <BaseInput3
              :model-value="value"
              @onChange="saveValue"
              :isDataUpdated="isDataUpdating"
              :isFormSubmitted="isSubmitted"
							:isHasError="fieldHasError"
							:errorText="errorText"
      ></BaseInput3>
	</div>
</template>
<script setup>
import { defineProps, ref, toRefs, defineEmits, onMounted } from "vue";
import BaseInput3 from "@/components/Base/BaseInput3.vue";

const props = defineProps({
  value: {
    type: String,
    required: true
  },
  type: {
    type: String,
		default: 'youtube'
  },
  label: {
    type: String,
    required: true
  },
  isDataUpdating: {},
  isSubmitted: {},
  objectKey: {},
  isFieldRequired: {},
  isDescriptionHtml: {},
  description: {}
});
const { value, type, label, isDataUpdating, isSubmitted, objectKey } = toRefs(props);

const emit = defineEmits(['onChange', 'update:value', 'update:type']);
let errorText = ref('');
let fieldHasError = ref(false);

function saveValue(val) {
  if (validateField(val)) {
    emit('update:value', val);
    emit('update:type', 'youtube');
    emit('onChange');
	}
}

function validateField(val) {
  if (!isYouTubeLink(val)) {
    errorText.value = 'Ссылка должна быть в формате https://www.youtube.com/watch?v=iWkpGslUNiM';
    fieldHasError.value = true;
    return false;
	} else {
    errorText.value = '';
    fieldHasError.value = false;
    return true;
	}
}

// onMounted(() => {
//   validateField();
// })


function isYouTubeLink(url) {
  var youtubeRegex = /^(http(s)?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/)|youtu\.be\/)\S+$/;
  return youtubeRegex.test(url);
}

</script>

<style scoped>
.field_label {
    margin-bottom: 15px;
		display: inline-block;
}

.field_description {
    font-size: 16px;
    color: rgba(34, 34, 34, 0.5);
    margin-bottom: 10px;
}
.field_label__wrapper {
    flex-grow: 1;
}
</style>